__turbopack_context__.v({
  "contactButton": "PhotographerPage-module__1WwTAa__contactButton",
  "contactButtonWrapper": "PhotographerPage-module__1WwTAa__contactButtonWrapper",
  "heartIcon": "PhotographerPage-module__1WwTAa__heartIcon",
  "liked": "PhotographerPage-module__1WwTAa__liked",
  "mediaContent": "PhotographerPage-module__1WwTAa__mediaContent",
  "mediaLikes": "PhotographerPage-module__1WwTAa__mediaLikes",
  "mediaPicture": "PhotographerPage-module__1WwTAa__mediaPicture",
  "mediasGrid": "PhotographerPage-module__1WwTAa__mediasGrid",
  "photographerHeader": "PhotographerPage-module__1WwTAa__photographerHeader",
  "photographerLocation": "PhotographerPage-module__1WwTAa__photographerLocation",
  "photographerName": "PhotographerPage-module__1WwTAa__photographerName",
  "photographerPortrait": "PhotographerPage-module__1WwTAa__photographerPortrait",
  "photographerPresentation": "PhotographerPage-module__1WwTAa__photographerPresentation",
  "photographerTagline": "PhotographerPage-module__1WwTAa__photographerTagline",
  "portraitWrapper": "PhotographerPage-module__1WwTAa__portraitWrapper",
  "sideInfos": "PhotographerPage-module__1WwTAa__sideInfos",
  "tags": "PhotographerPage-module__1WwTAa__tags",
  "tagsSelect": "PhotographerPage-module__1WwTAa__tagsSelect",
});
